import React from "react";

import { Breadcrumb } from "react-bootstrap";
import BookingListAll from "./BookingListAll";
import MasterLayout from "../../masterLayout/MasterLayout";

const UnpaidBookingStudent= ({status}) => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking List" />
      <BookingListAll status={status}/>
    </MasterLayout>
  );
};

export default UnpaidBookingStudent;
